import { StyledTable } from "../../styles/StyledUnit/StyledContent";
import { PropTypes } from "prop-types";
import DeleteIcon from "../../assets/img/icons/delete.svg";
import CloseIcon from "../../assets/img/icons/close.svg";
import SaveIcon from "../../assets/img/icons/save.svg";
import EditIcon from "../../assets/img/icons/edit-black.svg";
import { useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export default function AdminTableRow({ refetch, data, edit, setAddNew, openModal, setDeletedId, possibleToDelete, addFunc, editFunc, deleteFunc }) {
	const { axiosPrivate } = useAxiosPrivate();
	const [isEdit, setIsEdit] = useState(edit);
	const [taxonomyName, setTaxonomyName] = useState(data.name ? data.name : "");

	const handleChange = (e) => {
		setTaxonomyName(e.target.value);
	};

	const handleEdit = async () => {
		if (edit) {
			data.name = taxonomyName;
			await addFunc(axiosPrivate, refetch, { slug: taxonomyName.toLowerCase(), name: taxonomyName });
			setAddNew(false);
			setIsEdit(false);
		} else {
			data.name = taxonomyName;
			await editFunc(axiosPrivate, refetch, data.id, { slug: taxonomyName.toLowerCase(), name: taxonomyName });
			setIsEdit(false);
		}
	};

	const handleDelete = async () => {
		if (deleteFunc) {
			await deleteFunc(axiosPrivate, refetch, data.id);
		}
	};

	return (
		<StyledTable>
			{isEdit ? <input type="text" name="name" value={taxonomyName} onChange={(e) => handleChange(e)} /> : <span>{data.name}</span>}
			<div>
				{isEdit ? (
					<>
						<img onClick={() => handleEdit()} src={SaveIcon} alt={SaveIcon} role="img" />
						<img
							onClick={() => {
								setIsEdit(false);
								if (setAddNew) setAddNew(false);
							}}
							src={CloseIcon}
							alt={CloseIcon}
							role="img"
						/>
					</>
				) : (
					<>
						<img onClick={() => setIsEdit(true)} src={EditIcon} alt={EditIcon} role="img" />
						<img
							onClick={() => {
								if (openModal) {
									setDeletedId(data.id);
									openModal();
								}
							}}
							src={DeleteIcon}
							alt={DeleteIcon}
							role="img"
						/>
					</>
				)}
			</div>
		</StyledTable>
	);
}

AdminTableRow.propTypes = {
	data: PropTypes.object,
	edit: PropTypes.bool,
	setAddNew: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	refetch: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	openModal: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	setDeletedId: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	possibleToDelete: PropTypes.bool,
	addFunc: PropTypes.func,
	editFunc: PropTypes.func,
	deleteFunc: PropTypes.func,
};

AdminTableRow.defaultProps = {
	edit: false,
	setAddNew: false,
	refetch: false,
	openModal: false,
	setDeletedId: false,
	possibleToDelete: true,
};
